const localization = {
  en: {
    rangeResult: 'Result: '
  },
  es: {
    rangeResult: 'Resultado: '
  }
}

export default localization
